(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["replab-cinema"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 899px)');
  const motion = () => !reduced.matches && document.body.dataset.rlMotion === 'true';
  const safePlay = (video) => { const result = video.play(); if (result) result.catch(() => {}); };
  class RLCinema extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('[data-rl-parallax]');
      this.visible = false;
      this.frame = 0;
      this.update = () => {
        this.frame = 0;
        if (!this.media) return;
        const value = motion() && !mobile.matches ? Math.max(-35, Math.min(60, -this.getBoundingClientRect().top * .1)) : 0;
        this.media.style.setProperty('--rl-parallax', `${value}px`);
      };
      this.scroll = () => { if (this.visible && !this.frame) this.frame = requestAnimationFrame(this.update); };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; this.scroll(); });
        this.observer.observe(this);
        window.addEventListener('scroll', this.scroll, { passive: true });
      }
      reduced.addEventListener('change', this.update);
      mobile.addEventListener('change', this.update);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.scroll);
      reduced.removeEventListener('change', this.update);
      mobile.removeEventListener('change', this.update);
      cancelAnimationFrame(this.frame);
    }
  }
  class RLStory extends HTMLElement {
    connectedCallback() {
      this.chapters = [...this.querySelectorAll('[data-rl-chapter]')];
      this.images = [...this.querySelectorAll('[data-rl-image]')];
      this.count = this.querySelector('.rl-story__count');
      this.visible = false;
      this.frame = 0;
      this.update = () => {
        this.frame = 0;
        let active = 0;
        if (!mobile.matches && motion()) {
          this.chapters.forEach((chapter, index) => { if (chapter.getBoundingClientRect().top <= window.innerHeight * .52) active = index; });
        }
        this.images.forEach((image, index) => image.classList.toggle('is-active', index === active));
        if (this.count) this.count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(this.chapters.length).padStart(2, '0')}`;
      };
      this.scroll = () => { if (this.visible && !this.frame) this.frame = requestAnimationFrame(this.update); };
      this.select = (event) => {
        const chapter = event.target.closest('[data-rl-chapter]');
        if (!chapter || !this.contains(chapter)) return;
        const index = Number(chapter.dataset.rlChapter);
        this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; this.scroll(); });
        this.observer.observe(this);
        window.addEventListener('scroll', this.scroll, { passive: true });
      }
      window.addEventListener('resize', this.scroll, { passive: true });
      reduced.addEventListener('change', this.update);
      document.addEventListener('shopify:block:select', this.select);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.scroll);
      window.removeEventListener('resize', this.scroll);
      reduced.removeEventListener('change', this.update);
      document.removeEventListener('shopify:block:select', this.select);
      cancelAnimationFrame(this.frame);
    }
  }
  class RLCommunity extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.rl-community__rail');
      this.previous = this.querySelector('[data-rl-prev]');
      this.next = this.querySelector('[data-rl-next]');
      this.controls = this.querySelector('.rl-carousel-buttons');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const move = (direction) => {
        const card = this.rail.querySelector('.rl-community__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap || 0);
        this.rail.scrollBy({ left: direction * step, behavior: motion() ? 'smooth' : 'auto' });
      };
      this.update = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.controls.hidden = max < 2;
        this.previous.disabled = this.rail.scrollLeft < 2;
        this.next.disabled = this.rail.scrollLeft >= max - 2;
      };
      this.previous.addEventListener('click', () => move(-1), { signal });
      this.next.addEventListener('click', () => move(1), { signal });
      this.rail.addEventListener('scroll', this.update, { passive: true, signal });
      this.videos = [...this.querySelectorAll('video')];
      this.videos.forEach((video) => video.addEventListener('play', () => this.videos.forEach((other) => { if (other !== video) other.pause(); }), { signal }));
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver((entries) => entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: .1 });
        this.videos.forEach((video) => this.videoObserver.observe(video));
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.videos.forEach((video) => video.pause()); }, { signal });
      if ('ResizeObserver' in window) { this.resize = new ResizeObserver(this.update); this.resize.observe(this.rail); }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.videoObserver?.disconnect(); this.videos?.forEach((video) => video.pause()); }
  }
  class RLFilm extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      this.visible = false;
      this.attempted = false;
      this.sync = () => {
        if (!this.visible || document.hidden) { this.video.pause(); return; }
        if (this.hasAttribute('data-rl-autoplay') && motion() && !navigator.connection?.saveData && !this.attempted && !window.Shopify?.designMode) {
          this.attempted = true;
          safePlay(this.video);
        }
      };
      this.preference = () => { if (!motion()) this.video.pause(); };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: .35 });
        this.observer.observe(this.video);
      }
      document.addEventListener('visibilitychange', this.sync, { signal: this.abort.signal });
      reduced.addEventListener('change', this.preference);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); if (this.preference) reduced.removeEventListener('change', this.preference); this.video?.pause(); }
  }
  for (const [tag, definition] of [['rl-cinema', RLCinema], ['rl-story', RLStory], ['rl-community', RLCommunity], ['rl-film', RLFilm]]) {
    if (!customElements.get(tag)) customElements.define(tag, definition);
  }
  const initReveals = (root = document) => {
    if (!('IntersectionObserver' in window) || !motion()) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const element = entry.target;
        observer.unobserve(element);
        if (!motion()) return;
        const animation = element.animate([{ opacity: 0, transform: 'translateY(26px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 780, easing: 'cubic-bezier(.2,.7,.25,1)' });
        element.addEventListener('focusin', () => animation.finish(), { once: true });
      });
    }, { threshold: .08 });
    root.querySelectorAll('[data-rl-reveal]:not([data-rl-observed])').forEach((element) => { element.dataset.rlObserved = 'true'; observer.observe(element); });
    if (root !== document) root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
  };
  const start = () => initReveals();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', (event) => initReveals(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
